import PropTypes from "prop-types";
import React from "react";
import { Flex, ListIcon, ListItem } from "@chakra-ui/react";
import { CircleIcon } from "../Icons";

const ListItemDot = ({ color = "black", children, ...rest }) => {
  return (
    <ListItem {...rest}>
      <Flex>
        <ListIcon
          as={CircleIcon}
          boxSize="4px"
          ml="8px"
          mr="20px"
          mt="9px"
          color={color}
        />
        {children}
      </Flex>
    </ListItem>
  );
};

ListItemDot.propTypes = {
  /**
   * Text of the list item
   */
  children: PropTypes.node.isRequired,
  /**
   * Color string of the dot
   */
  color: PropTypes.string,
};

export default ListItemDot;
